import { css } from '@adornis/chemistry/directives/css.js';
import type { FormController } from '@adornis/forms/x-form-controller.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { languages } from '@chancenwerk/client/translation-data.js';
import type { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AnmeldungPageRegistrationBase } from './anmeldung-component-formular-base.js';

/**
 * @customElement anmeldung-component-formular-lang-select
 */
@customElement('anmeldung-component-formular-lang-select')
export class AnmeldungPageRegistrationLangSelect extends AnmeldungPageRegistrationBase {
  @property({ attribute: false }) form!: FormController<Student>;
  @property({ attribute: false }) translation!: TranslationController<any>;

  override render() {
    return html` <cr-flex space="xxl">
      <cr-flex horizontal center space="xxl">
        <cr-flex crossaxis-center space="md">
          <div
            ${css({
              width: '128px',
              height: '128px',
              backgroundPosition: 'center center',
              backgroundSize: '200%',
              backgroundRepeat: 'no-repeat',
              border: `5px solid`,
              borderRadius: '50%',
              borderColor: `${
                globalLanguageSubject.value === languages.german ? this.colors.accent : this.colors.neutral.shade(200)
              }`,
            })}
            @click=${() => globalLanguageSubject.next(languages.german)}
          ></div>
          <cr-h4> Deutsch</cr-h4>
        </cr-flex>
        <cr-flex crossaxis-center space="md">
          <div
            ${css({
              width: '128px',
              height: '128px',
              backgroundPosition: 'center center',
              backgroundSize: '200%',
              backgroundRepeat: 'no-repeat',
              border: `5px solid`,
              borderRadius: '50%',
              borderColor: `${
                globalLanguageSubject.value === languages.english ? this.colors.accent : this.colors.neutral.shade(200)
              }`,
            })}
            @click=${() => globalLanguageSubject.next(languages.english)}
          ></div>
          <cr-h4> English </cr-h4>
        </cr-flex>
      </cr-flex>
      <cr-flex horizontal space="md" end>
        <cr-button
          @click=${async () => {
            const eventDis = new CustomEvent('next-step', {});
            this.dispatchEvent(eventDis);
          }}
        >
          ${this.translation.translate('next')}
        </cr-button>
      </cr-flex>
    </cr-flex>`;
  }
}
